import { gql } from "@apollo/client"

export const STRIPE_TRANSACTION_INITIALIZE = gql`
  mutation stripePaymentInitialize($checkoutId: ID!, $paymentGateway: String!, $amount: PositiveDecimal, $data: JSON) {
    transactionInitialize(id: $checkoutId, amount: $amount, paymentGateway: { id: $paymentGateway, data: $data }) {
      transaction {
        id
      }
      transactionEvent {
        pspReference
        amount {
          amount
          currency
        }
        type
      }
      data
      errors {
        field
        message
        code
      }
    }
  }
`
